<template>
  <div>
    <section>
			<div class="container">
				<figure>
          <img src="/static/images/index/i80banner.png" class="img-responsive">
        </figure>
			</div>
		</section>
    <section>
        <div class="container">
            <ol class="breadcrumb hidden-xs">
                <li><a href="/">首頁</a></li>
                <li><a href="/product">商品</a></li>
                <li class="active">商品列表</li>
            </ol>
            <div class="row">
              <center>
                <form class="navbar-form" @submit.prevent>
                    <select class="form-control" name="catalog">
                        <option v-for="option in catalog" v-bind:value="option.text">
                            {{option.text}}
                        </option>
                    </select>
                    <div class="form-group">
                        <input type="text" v-model="keyword" class="form-control" placeholder="請輸入產品名稱">
                    </div>
                    <button type="button" @click="ProductSearch()" class="btn btn-success">查詢</button>
                </form>
              </center>
            </div>
            <div class="row">
              <!--產品區-->
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="col-md-3 col-sm-4 col-xs-6" v-for="(item, index) in productList">
                  <div class="product_box">
                      <figure class="pic justify">
                        <a :href="'/product/'+item.id">
                          <img :src="'https://files.i80.com.tw/images/product/'+item.imageM" class="img-responsive"/>
                        </a>
                      </figure>
                      <center>
                        <h5 class="title">{{item.name}}</h5>
                        <span class="price" v-if="item.price > 0">{{item.price}}</span>
                        <span class="points" v-if="item.price > 0 && item.point">{{ item.point }}點</span>
                        <br/>
                        <button class="addcart btn btn-default i80_btn" type="button"  @click="addToCart(item)">
                          <span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> 加入購物車
                        </button>
                      </center>
                  </div>
                </div>
              </div>
            </div>
          <!--End-->
        </div>
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'Product',
  data () {
    return {
      productList: '',
      promoteList: [],
      keyword: '',
      priceFlag: true,
      catalog: [
        { text: '日常用品', value: 1 },
        { text: '大眾商品', value: 2 },
        { text: '休閒旅遊', value: 3 },
        { text: '影音藝文', value: 4 },
        { text: '美容美妝', value: 5 },
        { text: '3c商品', value: 6 },
        { text: '生活服務', value: 7 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      userID: 'getUserID'
    })
  },
  mounted: function () {
    let products = localStorage.getItem('products')
    products = JSON.parse(products)
    this.productList = products.sort(function (a, b) {
      return a.sorting - b.sorting
    })
  },
  methods: {
    ...mapActions([
      'ADD_TO_CART'
    ]),
    addToCart (row) {
      this.$store.dispatch('ADD_TO_CART', row)
    },
    ProductSearch () {
      let keyword = this.keyword
      if (keyword !== '') {
        this.productList = this.productList.filter(function (value) {
          return value.name.indexOf(keyword) >= 0
        })
      } else {
        this.productList = this.$store.getters.getProducts
      }
    },
    even (arr) {
      return arr.sort(function (a, b) {
        return a.sorting - b.sorting
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Product.vue?503d1d56